import VueForm from '../../../scripts/VueFormSetup'
var ForgotPassword = VueForm.FormSubmit('ForgotPassword',
    {
        Email: '',
        valid: '',
    },
    'ID')
ForgotPassword.methods.complete = function (params) {
    var instance = this
    if (params.status === 'success') {
        if (params.data === 'OK') {
            this.$root.$snackbar('Por favor revise su correo electrónico para restablecer su contraseña.', { color: 'success' })
            this.Email = ''
            this.$router.replace("/")
        }
        else {
            this.$root.$snackbar('La solicitud se realizó con éxito, pero no pudimos determinar qué sucedió en esta solicitud. Si el error persiste, póngase en contacto con el equipo de soporte.', { color: 'error' })
        }
    } else {
        this.$root.$snackbar('No pudimos determinar qué sucedió en esta solicitud. Por favor, compruebe su conexión a Internet y vuelva a intentarlo. Si el error persiste, póngase en contacto con el equipo de soporte.', { color: 'error' })
    }
}
export default ForgotPassword


// WEBPACK FOOTER //
// ./src/components/account/forgotPassword/script.js